<script setup lang="ts">
interface IProps {
  modelValue?: boolean
  error?: string
  togglePosition?: 'end' | 'start'
}

interface IEmits {
  (event: 'update:modelValue', value: boolean): void
}

const props = withDefaults(
  defineProps<IProps>(),
  {
    togglePosition: 'end',
  },
)
const emit = defineEmits<IEmits>()

const value = useVModel(props, 'modelValue', emit)

const { colors } = useTheme()
</script>

<template>
  <label flex items-center gap-3 cursor-pointer @click.prevent="value = !value">
    <div
      v-if="togglePosition === 'start'"
      w-6 h-4 px-1 rounded-full border flex items-center relative :style="{
        backgroundColor: value ? colors.softBlack : colors.darkGray,
        borderColor: value ? colors.softBlack : colors.darkGray,
      }" duration-125
    >
      <div
        w="10px" h="10px" bg-white rounded-full absolute top="50%" transform translate-y="-50%" :style="{
          left: value ? 'calc(100% - 13px)' : '3px',
          transition: 'left 0.2s ease',
        }"
      />
    </div>

    <slot name="label" />

    <input
      v-model="value"
      type="checkbox" display-none v-bind="$attrs"
    >

    <div
      v-if="togglePosition === 'end'"
      w-6 h-4 px-1 rounded-full border flex items-center relative :style="{
        backgroundColor: value ? colors.softBlack : colors.darkGray,
        borderColor: value ? colors.softBlack : colors.darkGray,
      }" duration-125
    >
      <div
        w="10px" h="10px" bg-white rounded-full absolute top="50%" transform translate-y="-50%" :style="{
          left: value ? 'calc(100% - 13px)' : '3px',
          transition: 'left 0.2s ease',
        }"
      />
    </div>

    <TextV2 v-if="error" small class="color-red-500">
      {{ error }}
    </TextV2>
  </label>
</template>
